import { CollectionRepository, Id } from '../abstraction';
import { ReadonlyHttpApiCollectionRepository } from './readonly-http-api-collection.repository';
import { ApiResourceLocation } from '../../data-access/types/api.location';
import { ApiDataAccess } from '../../data-access/api.data-access';
import { Dictionary } from '../../types/dictionary';
import { toIdString } from '../functions/to-id-string';

export abstract class HttpApiCollectionRepository<TItem, TResult, TCrudResult, TLoadParams = undefined, TCrudParams = undefined> extends ReadonlyHttpApiCollectionRepository<TResult, TLoadParams> implements CollectionRepository<TItem, TResult, TCrudResult, TLoadParams, TCrudParams> {

  protected constructor(dataAccess: ApiDataAccess,
                        path: string | string[]) {
    super(dataAccess, path);
  }

  create(value: TItem, params: TCrudParams): Promise<TCrudResult> {
    const location: ApiResourceLocation = {
      path: this.path,
      pathParams: this.getCRUDPathParams(params)
    }
    return this.dataAccess.create(location, value);
  }

  update(id: Id, value: TItem, params: TCrudParams): Promise<TCrudResult> {
    const path = this.getItemPath(id);
    const location: ApiResourceLocation = {
      path: path,
      pathParams: this.getCRUDPathParams(params)
    }
    return this.dataAccess.update(location, value);
  }

  patch(id: Id, changes: Partial<TItem>, params: TCrudParams): Promise<TCrudResult> {
    const path = this.getItemPath(id);
    const location: ApiResourceLocation = {
      path: path,
      pathParams: this.getCRUDPathParams(params)
    }
    return this.dataAccess.patch(location, changes);
  }

  delete(id: Id, params: TCrudParams): Promise<TCrudResult> {
    const path = this.getItemPath(id);
    const location: ApiResourceLocation = {
      path: path,
      pathParams: this.getCRUDPathParams(params)
    }
    return this.dataAccess.delete(location);
  }

  protected getItemPath(id: Id): string[] {
    if(Array.isArray(this.path))
      return [...this.path, toIdString(id)];
    else
      return [this.path, toIdString(id)];
  }

  protected abstract getCRUDPathParams(params: TCrudParams): Dictionary<unknown> | undefined;
}
